import React from 'react'
import { Block } from '@xprog/prensa'
import * as t from './Tag.types'

const Container: React.FC<t.ContainerProps> = (props) =>
  <Block
    css={{
      ...props.defaultCss,
      ...props.customCss
    }}>
    {props.children}
  </Block>

Container.defaultProps = {
  defaultCss: {
    align: ['row', 'center', 'middle'],
    background: '$transparent',
  }
}

export {
  Container
}